import Button from '@jobseeker/lotus/elements/ButtonV2';
import {Box, Typography, useTheme} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CTAProps} from '../type';
import {Send} from '@jobseeker/lotus/icons';

export default ({children, ...props}: CTAProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        borderRadius: 4,
        alignItems: 'center',
        background: 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
        px: 2,
        gap: theme.spacing(1),
        py: {xxs: 2, md: 2.5},
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: theme.spacing(1),
          zIndex: 2,
          // alignItems: 'center',
          // flexWrap: 'wrap',
          width: {xxs: '100%', sm: '73.5%', md: '70%', lg: '80%'},
        }}
      >
        <Box
          sx={{
            width: 25,
            minWidth: 25,
            height: 25,
            position: 'relative',
            // background: '#fff',
          }}
        >
          <Image
            alt="some image"
            src={props.imageUrl || Send}
            layout="fill"
            objectFit="contain"
            quality={100}
          />
        </Box>
        <Box
          display={{xxs: 'block', md: 'flex'}}
          columnGap={1}
          flexWrap={'wrap'}
        >
          <Typography
            variant="body1"
            fontSize={{xxs: 14, md: 16}}
            fontWeight={500}
            color={'#fff'}
          >
            {props.title}
          </Typography>
          <Typography
            variant="body2"
            fontSize={{xxs: 12, md: 16}}
            fontWeight={500}
            color={'#fff'}
          >
            {props.subTitle}
          </Typography>
        </Box>
      </Box>
      {!!props.actionLabel && (
        <Button
          variant="contained"
          disableRipple
          sx={{
            background: '#fff',
            mr: {md: 4},
            ml: {xxs: 4.5, sm: 0},
            fontSize: theme.typography.pxToRem(12),
            py: {xxs: 0.7, md: 1},
            px: 2,
            color: '#000',
            zIndex: 2,
            ':hover': {background: '#efefef'},
          }}
          size="small"
          href={props?.actionUrl}
          target="_self"
        >
          {props.actionLabel ?? 'Know More'}
        </Button>
      )}
    </Box>
  );
};
